<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    :right="right_support"
  >
    <v-list-item>
      <v-list-item-avatar>
        <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>John Leider</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list v-if="get_user_image() ==''" dense>
      <v-list-item
        link
        @click="$router.push({path:'/login'})"

      >
        <v-list-item-icon>
          <v-icon>mdi-account-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('signIn') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense>
      <v-list-item
        link
        @click="$router.push({path:'/contact-us'})"

      >
        <v-list-item-icon>
          <v-icon>mdi-send-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('contactus') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense>
      <v-list-item
        link
        @click="$router.push({path:'/about'})"

      >
        <v-list-item-icon>
          <v-icon>mdi-alert-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('aboutus') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense>
      <v-list-item
        link
        @click="$router.push({path:'/blog'})"
      >
        <v-list-item-icon>
          <v-icon>mdi-bell-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('blog') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense>
      <v-list-item
        link
        @click="$router.push({path:'/questions'})"

      >
        <v-list-item-icon>
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('questions') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
<!--    <v-list dense>-->
<!--      <v-list-item-->
<!--        link-->
<!--      >-->
<!--        <v-list-item-icon>-->
<!--          <v-icon>mdi-play-circle-outline</v-icon>-->
<!--        </v-list-item-icon>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>{{ $t('films') }}</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->
<!--    </v-list>-->
    <v-list v-if="get_user_image() !=''" dense>
      <v-list-item
        link
        @click="logout()"

      >
        <v-list-item-icon>
          <v-icon>mdi-location-exit</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('exit') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>

  import {bus} from '../main.js'

  export default {
    name: 'NavigationDrawer',
    components: {},
    data() {
      return {
        drawer: false,
        right_support: false,
        items: [
          {title: 'Home', icon: 'mdi-home-city'},
          {title: 'My Account', icon: 'mdi-account'},
          {title: 'Users', icon: 'mdi-account-group-outline'},
        ],
      }
    },
    mounted() {
      if (process.env.VUE_APP_I18N_DIRECTION == 'rtl') {
        this.right_support = true
      } else {
        this.right_support = false
      }

      bus.$on('toggle_drawer', (name) => {
        console.log('toggle drawer', 'name')
        this.drawer = !this.drawer
        // setTimeout(this.load = name , 1000)
      })
    },
    watch: {},
    methods: {
      logout() {
        localStorage.setItem('profile', null)
        location.reload()
      }
    }
  }
</script>
